/* eslint-disable import/no-unused-modules */
import * as TooltipPrimitive from '@radix-ui/react-tooltip';
import React, { useState } from 'react';

import { Placement, TooltipProps } from './types';
import { TooltipArrowStyled, TooltipContainerStyled, TooltipContentStyled, TooltipTitleStyled } from './styles';

const DEFAULT_PLACEMENT: Placement = 'right';
const TOOLTIP_SIDE_OFFSET = 6;

const placementToSideAlign = (
  placement: Placement,
): {
  side: 'top' | 'right' | 'bottom' | 'left';
  align: 'start' | 'center' | 'end';
} => {
  const [side, maybeAlign] = placement.split('-') as [
    Placement extends `${infer T}-${string}` ? T : never,
    'start' | 'end' | undefined,
  ];

  return {
    side,
    align: maybeAlign ?? 'center',
  };
};

export const Tooltip = ({ children, placement: desiredPlacement = DEFAULT_PLACEMENT, title }: TooltipProps): JSX.Element => {
  const [open, setOpen] = useState(false);
  const { side, align } = placementToSideAlign(desiredPlacement);

  return (
    <TooltipPrimitive.Provider delayDuration={0} skipDelayDuration={0} disableHoverableContent>
      <TooltipPrimitive.Root open={open} onOpenChange={setOpen}>
        <TooltipPrimitive.Trigger asChild>
          <TooltipContainerStyled
            onMouseEnter={() => setOpen(true)}
            onMouseLeave={() => setOpen(false)}
            onFocusCapture={() => setOpen(true)}
            onBlurCapture={() => setOpen(false)}
          >
            {children}
          </TooltipContainerStyled>
        </TooltipPrimitive.Trigger>
        <TooltipPrimitive.Portal>
          <TooltipContentStyled side={side} align={align} sideOffset={TOOLTIP_SIDE_OFFSET} avoidCollisions>
            <TooltipPrimitive.Arrow asChild width={16} height={6}>
              <TooltipArrowStyled viewBox="0 0 24 8" aria-hidden="true">
                <path d="M3 8s2.021-.015 5.253-4.218C9.584 2.051 10.797 1.007 12 1c1.203-.007 2.416 1.035 3.761 2.782C19.012 8.005 21 8 21 8H3z" />
              </TooltipArrowStyled>
            </TooltipPrimitive.Arrow>
            <TooltipTitleStyled>{title}</TooltipTitleStyled>
          </TooltipContentStyled>
        </TooltipPrimitive.Portal>
      </TooltipPrimitive.Root>
    </TooltipPrimitive.Provider>
  );
};
